import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LeadDetailsState,
  LeadDetails,
  CampaignLeadDetail,
  TimelineLog,
  Attachment,
} from "../../pages/Communications/utils/types";

const initialState: LeadDetailsState = {
  selectedLeadDetails: null,
  attachments: [],
  campaignLeadDetails: [],
  timelineLogs: [],
  loading: false,
  error: null,
  leadType: "",
};

const leadDetailsSlice = createSlice({
  name: "playgroundLeadDetails",
  initialState,
  reducers: {
    setLeadDetails: (state, action: PayloadAction<LeadDetails>) => {
      state.selectedLeadDetails = action.payload;
    },
    setAttachments: (state, action: PayloadAction<Attachment[]>) => {
      state.attachments = action.payload;
    },
    updateLeadDetails: (state, action: PayloadAction<Partial<LeadDetails>>) => {
      if (state.selectedLeadDetails) {
        state.selectedLeadDetails = {
          ...state.selectedLeadDetails,
          ...action.payload,
        };
      } else {
        state.selectedLeadDetails = action.payload as LeadDetails;
      }
    },
    clearLeadDetails: (state) => {
      state.selectedLeadDetails = null;
      state.timelineLogs = [];
      state.attachments = [];
      state.campaignLeadDetails = [];
    },
    setCampaignLeadDetails: (
      state,
      action: PayloadAction<CampaignLeadDetail[]>
    ) => {
      state.campaignLeadDetails = action.payload;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTimelineLogs: (state, action: PayloadAction<TimelineLog[]>) => {
      state.timelineLogs = action.payload;
    },
    clearTimelineLogs: (state) => {
      state.timelineLogs = [];
    },
    clearCampaignLeadDetails: (state) => {
      state.campaignLeadDetails = [];

      state.error = null;
    },
  },
});

export const {
  setLeadDetails,
  updateLeadDetails,
  setAttachments,
  clearLeadDetails,
  setCampaignLeadDetails,
  setLoading,
  setError,
  clearCampaignLeadDetails,
  setTimelineLogs,
  clearTimelineLogs,
} = leadDetailsSlice.actions;

export default leadDetailsSlice;
